import { useEffect } from 'react';
import { bonusApi  }                    from '../services/bonus/api';
import { qbaEmployeeIdb, QbaEmployeeCacheKey }  from '../services/cache/qbaEmployeeIdb';

interface FetchConfig {
  jobFamily:       string;
  applicationType?: string;
}

const ROLE_CONFIG: Record<string, FetchConfig> = {
  'DCCM':        { jobFamily: 'CUSTOMER CARE' },
  'DCCM-Review': { jobFamily: 'CUSTOMER CARE' },
  'DCCM_Review': { jobFamily: 'CUSTOMER CARE' },
  'DM':          { jobFamily: 'CONSTRUCTION'  },
  'DM-Review':   { jobFamily: 'CONSTRUCTION'  },
  'VP':          { jobFamily: 'CUSTOMER CARE', applicationType: 'DCCM' },
  'VP-Review':   { jobFamily: 'CUSTOMER CARE', applicationType: 'DCCM' },
};

async function prefetchForRole(config: FetchConfig, isExEmployee: boolean): Promise<void> {
  const key: QbaEmployeeCacheKey = {
    jobFamily:      config.jobFamily,
    applicationType: config.applicationType,
  };

  const cached = await qbaEmployeeIdb.get(key);
  if (cached) return; // still valid

  const employees = await bonusApi.getEmployees({ ...config, isExEmployee });
  await qbaEmployeeIdb.set(key, employees);
}

export function useEmployeePrefetch(selectedRole: string): void {
  useEffect(() => {
    const config = ROLE_CONFIG[selectedRole];
    if (!config) return;

    prefetchForRole(config, false).catch(console.error);
    prefetchForRole(config, true).catch(console.error);
  }, [selectedRole]);
}